import type { PhoneInventory } from '../lib/selfPhoneProduct';

type Props = {
  inventory: PhoneInventory;
  loading?: boolean;
};

export default function PhoneAvailabilityCounter({ inventory, loading }: Props) {
  const claimedPct =
    inventory.total > 0 ? Math.min(100, (inventory.sold / inventory.total) * 100) : 0;

  return (
    <div className="mt-4 rounded-xl border border-white/15 bg-white/5 px-4 py-3">
      <div className="flex flex-wrap items-center justify-between gap-2 text-sm">
        <span className="text-white/65">
          {loading
            ? 'Checking availability…'
            : inventory.soldOut
              ? 'All 50 phones have been claimed'
              : `${inventory.remaining} of ${inventory.total} phones available`}
        </span>
        {!loading && !inventory.soldOut && (
          <span className="font-medium text-white/80">{inventory.sold} claimed</span>
        )}
      </div>
      <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-white/10">
        <div
          className="h-full bg-white transition-all duration-500 ease-out"
          style={{ width: loading ? '0%' : `${claimedPct}%` }}
        />
      </div>
    </div>
  );
}
